import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FaderComponent } from './fader/fader.component';
import { HttpModule } from '@angular/http';
import { FontStylesComponent } from './font-styles/font-styles.component';
import { CbsLogoComponent } from './cbs-logo/cbs-logo.component';
import { CbsIconComponent } from './cbs-icon/cbs-icon.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HttpModule,
  ],
  declarations: [
    FaderComponent,
    FontStylesComponent,
    CbsLogoComponent,
    CbsIconComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    // MomentModule,
    FaderComponent,
    FontStylesComponent,
    CbsLogoComponent,
    CbsIconComponent,
    TranslateModule,
  ]
})
export class SharedModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts